import React from 'react';

import classes from './Version.module.scss';

export default () => {
	return <div className={classes.Root}>Client Version: {process.env.REACT_APP_VERSION}</div>
}